import { selectedPeriodVar } from 'app/apollo/reaction';
import { useEveryInHiddenPeriod } from 'app/containers/BasketResolver';
import { setInitialPeriodAsQueryParam } from 'app/containers/contexts/filters.context/filters.context';
import { useMenuPeriodsData } from 'app/hooks/accessors';
import React from 'react';

export const useSwitchToFirstVisiblePeriod = () => {
    const isEveryInHiddenPeriod = useEveryInHiddenPeriod();
    const { periods } = useMenuPeriodsData();

    return () => {
        if (!isEveryInHiddenPeriod) return null;
        const firstPeriod = periods.find((itm) => itm.isVisibleInFilter === 'visible');
        console.log('set next period', firstPeriod);
        setInitialPeriodAsQueryParam(firstPeriod.start);
        selectedPeriodVar(firstPeriod.start);
    };
};
